import React from "react";
import { Dialog, Button } from "@material-ui/core";
import {useDispatch, useSelector} from 'react-redux';
import type {ModalState} from '../../redux/reducers/modalReducer';
import {closeModal} from '../../redux/reducers/modalReducer';
import Util from '../../services/Util';

const AlertModal = () => {
  const dispatch = useDispatch();
  const {open, message, title, style, error}: ModalState = useSelector(s => s['modal']);
  return (
    <Dialog
      maxWidth="xs"
      fullWidth={true}
      open={open && style === 'alert'}
    >
      <div className="p-24">
        <h4 className="capitalize">{error ? 'error' : title ?? 'alert'}</h4>
        <p>{error ? Util.getErrorMessage(error) : message}</p>
        <div className="flex flex-center pt-8">
          <Button onClick={() => closeModal(dispatch)} variant="contained" color="secondary">
            <span className={'text-white'}>Close</span>
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default AlertModal;
